import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useState } from "react";

type IProps = {
  formik: any;
  color?: any;
  sx?: any;
  label?: any;
  name?: string;
};

const FormikPassword: React.FC<IProps> = ({
  formik,
  sx = {},
  color = "primary",
  label = "Password",
  name = "password",
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  return (
    <FormControl sx={sx} variant="outlined" fullWidth>
      <InputLabel error={formik.touched[name] && Boolean(formik.errors[name])}>
        {label}
      </InputLabel>
      <OutlinedInput
        name={name}
        type={showPassword ? "text" : "password"}
        value={formik.values[name]}
        onChange={(e) => {
          formik.handleChange(e);
        }}
        inputProps={{
          autocomplete: "new-password",
        }}
        error={formik.touched[name] && Boolean(formik.errors[name])}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {showPassword ? (
                <VisibilityOff color={color} sx={{ opacity: 0.5 }} />
              ) : (
                <Visibility color={color} sx={{ opacity: 0.5 }} />
              )}
            </IconButton>
          </InputAdornment>
        }
        label={label}
      />
      {formik.touched[name] && formik.errors[name] && (
        <FormHelperText error>
          {formik.touched[name] && formik.errors[name]}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default FormikPassword;
